import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import apiMethods from '../../../apis';
import useFetch from '../../../services/hooks/http/useFetch';
import useGet from '../../../services/hooks/http/useGet';
import { stringSchema } from '../../../services/schemas';
import { formTypes } from '../../../store/catalogs/forms';
import Context from '../../../store/context';
import { setBusiness } from '../../../store/slices/user';
import BackButton from '../../Buttons/BackButton/BackButton';
import Button from '../../Buttons/Button/Button';
import LabelFieldFormik from '../../Fields/LabelField/LabelFieldFormik';
import FormGrid from '../../Form/FormGrid/FormGrid';
import NoticeCard from '../../NoticeCard/NoticeCard';

import classes from './FormAgreement.module.scss';
import { messageErrorFormAgreement } from '../../../store/constants/messageErrors';

const validationSchema = Yup.object().shape({
  agreementId: stringSchema(messageErrorFormAgreement.agreementId),
  referenceId: stringSchema(messageErrorFormAgreement.referenceId),
  description: stringSchema(messageErrorFormAgreement.description)
});

const valuesFormik = {
  //category: categorySelected.value,
  agreementName: '',
  agreementId: '',
  referenceId: '',
  description: ''
};

const FormAgreement = ({ categorySelected, clickBack }) => {
  const { businessId } = useSelector(state => state.userData);

  const {
    modal: { showError, hideModal },
    toast: { showSuccess }
  } = useContext(Context);

  const {
    isSuccess: MoviiAgreementsIsSuccess,
    data: MoviiAgreementsItems,
    isError: MoviiAgreementsIsError
  } = useGet(apiMethods.getMoviiAgreements, [categorySelected.value], true);

  const dispatch = useDispatch();

  const {
    isSuccess: updateSuccess,
    sendRequest: updateBusiness,
    isError: updateError,
    errorMessage,
    data: updateData
  } = useFetch(apiMethods.updateBusiness);

  const fields = [
    {
      key: 'agreementId',
      label: 'Empresa o servicio',
      type: formTypes.select,
      options: []
    },
    { key: 'referenceId', label: 'Número', type: formTypes.number },
    { key: 'description', label: 'Descripción' }
  ];
  const [fieldsState, setfieldsState] = useState(fields);

  useEffect(() => {
    if (MoviiAgreementsIsSuccess) {
      setfieldsState(fields => {
        const newFields = [...fields];
        newFields[0] = {
          ...newFields[0],
          options: MoviiAgreementsItems.map(agreements => ({ value: agreements.agreementId, label: agreements.agreementName }))
        };
        return newFields;
      });
    } else if (MoviiAgreementsIsError) {
    }
  }, [MoviiAgreementsIsError, MoviiAgreementsIsSuccess, MoviiAgreementsItems]);

  const createAgreement = ({ agreementName, agreementId, referenceId, description }) => {
    updateBusiness(businessId, {
      newAgreement: {
        agreementName,
        agreementId,
        referenceId,
        description,
        categoryLabel: categorySelected.label,
        categoryId: categorySelected.value
      }
    });
  };

  useEffect(() => {
    if (updateSuccess) {
      showSuccess('Convenio creado');
      dispatch(setBusiness({ businessId, businessData: updateData }));
      hideModal();
    } else if (updateError) {
      showError({ title: 'Crear convenio', description: errorMessage });
    }
  }, [businessId, dispatch, errorMessage, hideModal, showError, showSuccess, updateData, updateError, updateSuccess]);

  const setValue = (setFieldValue, key, value) => {
    setFieldValue(key, value);
    if (key === 'agreementId') {
      const { label: agreementName } = fieldsState[0].options.find(option => option.value === value);
      setFieldValue('agreementName', agreementName);
    }
  };

  return (
    <div className={classes.content}>
      <BackButton onClick={clickBack} />
      <span className='medium-16'>Categoría: {categorySelected.label}</span>
      <span className='bold-20'>Agregar nueva empresa/servicio</span>
      <span className='semibold-18'>Ingresa la empresa y el número de referencia</span>
      <Formik initialValues={valuesFormik} validationSchema={validationSchema} onSubmit={createAgreement}>
        {({ setFieldValue }) => (
          <Form id='formAgreement' className={classes.form}>
            <FormGrid onChange={(key, value) => setValue(setFieldValue, key, value)} fields={fieldsState} Render={LabelFieldFormik} />

            <NoticeCard
              className={classes.notice}
              text='Al conectar un convenio, las cuentas de cobro llegarán automáticamente al módulo de Cuentas de cobro para pagarlas todos los meses a través de Melo. Esta acción no restringe el pago por otros medios.'
            />
            <div className={classes.down}>
              <Button className={classes.button} type='submit'>
                Continuar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormAgreement;
